export const ADD_TO_CART = "ADD_TO_CART";
export const EDIT_CART = "EDIT_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CART_RESET = "CART_RESET";
export const SAVE_ADDRESS = "SAVE_ADDRESS";
export const SAVE_PAYMENT_METHOD = "SAVE_PAYMENT_METHOD";
